import { takeLatest, fork, put, all, call } from 'redux-saga/effects'

import i18n from 'i18n'
import { usersAPI } from 'features/users/api'
import { usersUsersMentorsList } from './slice'
import { RequestUtils } from 'utils'

function* getList({ payload: { params } }) {
  try {
    let requestParams = {
      includes: ['avatar', 'studentProfile'],
    }

    requestParams = RequestUtils.getMapRequestParams(params, requestParams)

    const response = yield call(usersAPI.getMentors, requestParams)

    const { data } = response

    const {
      meta: { current_page, last_page },
    } = data

    if (current_page && last_page && current_page > last_page) {
      yield put(
        usersUsersMentorsList.getList({
          params: {
            ...params,
            page: last_page,
          },
        })
      )
    } else {
      yield put(usersUsersMentorsList.getListSuccess(data))
    }
  } catch (error) {
    const message = error.response?.data?.message || i18n.t('error')
    yield put(usersUsersMentorsList.getListError(message))
  }
}

function* watchGetList() {
  yield takeLatest(usersUsersMentorsList.getList, getList)
}

function* cleanState() {
  yield put(usersUsersMentorsList.cleanState({}))
}

export function* listSaga() {
  yield all([fork(watchGetList)])
}
